// src/encounter/rail-v3/rail-v3-contacts.tsx
// The rail's Contacts section (left-rail target §1, the non-clinical block), drawn with Antonin's catalogue parts (@scripsteam/signal
// PatientRailSection, PatientRailRow, PatientRailIconButton; §5). An adapter only: the same contacts and the same call action per
// contact (a phone number → "Call <name>") as the patient card drew them (chart-column-v2.tsx ChartColumnPersonCard). No look here.
import { Phone } from 'lucide-react';
import { PatientRailIconButton, PatientRailRow, PatientRailSection } from '@scripsteam/signal';
import type { ContactVM } from '../lib/to-patient-contacts';

export const RAIL_CONTACTS_TITLE = 'Contacts';

/** Opens the device's dialler for `phone` (what the card's `tel:` link did). */
function callContact(phone: string): void {
  window.location.assign(`tel:${phone}`);
}

/** The rail's contacts section. Nothing at all when there are no contacts (the card drew none either). */
export function RailV3Contacts({ contacts, defaultOpen = true }: { contacts?: readonly ContactVM[]; defaultOpen?: boolean }) {
  if (!contacts || contacts.length === 0) return null;
  return (
    <PatientRailSection title={RAIL_CONTACTS_TITLE} count={contacts.length} folded={!defaultOpen}>
      <ul aria-label={RAIL_CONTACTS_TITLE} className="flex flex-col gap-1">
        {contacts.map((c) => {
          const relation = [c.relation, c.isProxy ? 'Proxy' : undefined].filter(Boolean).join(' · ');
          return (
            <PatientRailRow key={c.id} row={`contact:${c.id}`} title={c.name} name={c.name} detail={relation || undefined}>
              {c.phone ? (
                <PatientRailIconButton name={`Call ${c.name}`} tip="Call" onClick={() => callContact(c.phone!)}>
                  <Phone aria-hidden />
                </PatientRailIconButton>
              ) : null}
            </PatientRailRow>
          );
        })}
      </ul>
    </PatientRailSection>
  );
}
